











































































import {
  defineComponent,
  PropType,
  onMounted,
  ref,
  computed,
} from '@vue/composition-api';
import type { IncreaseCreditInfoType, IncreaseCreditListType, IncreaseContractType } from '@/api/increase-credit/increase-credit-zone/types';
import { checkWebRTC } from '@/shared/tools/startLiveness/utils';
import platform from '@/shared/utils/platform';
import { Toast, CellGroup, Cell } from '@hb/coffee';
import { getIncreaseCreditContract } from '@/api/increase-credit/increase-credit-zone';
import { ubtSetupModuleExpose, ubtSetupPageButton } from '@/shared/utils/ubt/ubt-setup';
import { jumpToNewVersion } from '@/shared/utils/jumpTo';
import { openThirdPage, checkPermission } from '@/api/native/utils';
import { NewVersionEnum } from '@/enums/newVersionRoute';
import { ubtSendError } from '@/shared/utils/ubt';
import ZoneSubmitDialog from '@/views_v2/home/components/zone-submit-dialog';

export enum IncreaseCreditTypeEnum {
  /** 认证类型 */
  AUTH_LIST = 'authList',
  /** 车抵贷 */
  CAR_LOAN = 'carLoan',
}

/**
 * 提额降息专区
 */
export default defineComponent({
  name: 'IncreaseCreditZone',
  components: {
    CellGroup,
    Cell,
    ZoneSubmitDialog,
  },
  props: {
    increaseCreditInfo: {
      type: Object as PropType<IncreaseCreditInfoType>,
      required: true,
    },
  },
  setup(props) {
    const authDialogVisible = ref(false);
    const currentSelectData = ref<IncreaseCreditListType | undefined>(undefined);
    const currentDataContract = ref<IncreaseContractType | undefined>(undefined);
    const { adjustAuthList = [], carLoanList = [] } = props.increaseCreditInfo || {};
    /** 提额专区列表，若"认证列表"为空的时候，“车抵贷列表”才会作为兜底数据返回 */
    const increaseCreditList = computed(() => {
      if (adjustAuthList?.length) {
        return {
          list: adjustAuthList,
          type: IncreaseCreditTypeEnum.AUTH_LIST,
        };
      }
      return {
        list: carLoanList,
        type: IncreaseCreditTypeEnum.CAR_LOAN,
      };
    });

    /** 去认证 */
    const goAuthentication = async (item: IncreaseCreditListType) => {
      ubtSetupPageButton('finance_qualityHomePage_increaseCredit_toAuthenticate', {
        dataType: item.authId,
      });
      // 以下场景均为app场景下的判断，若后续需要在h5、支付宝小程序中开放入口，则需要做相应的判断处理
      if (item.needFace) {
        const toastMsg = '此认证项需要打开相机权限，请您先开启';
        if (platform.isIOS && !(await checkWebRTC())) {
          Toast(toastMsg);
          return;
        }
        if (platform.isAndroid || platform.isHarmony) {
          const { status } = await checkPermission(2);

          if (!status) {
            Toast(toastMsg);
            return;
          }
        }
      }
      currentSelectData.value = item;
      try {
        currentDataContract.value = await getIncreaseCreditContract(item.authId);
      } catch (error) {
        currentDataContract.value = undefined;
        ubtSendError(error as Error);
      }

      /** 认证弹窗 */
      authDialogVisible.value = true;

      ubtSetupModuleExpose('finance_qualityHomePage_increaseCredit_confirmPopUp');
    };

    /** 去申请 */
    const goApply = (item: IncreaseCreditListType) => {
      if (item.jumpUrl) {
        ubtSetupPageButton('finance_qualityHomePage_carLoan_apply');
        openThirdPage(item.jumpUrl);
      } else {
        ubtSendError(new Error('carLoan jumpUrl is empty'));
      }
    };

    const onListButtonClick = (type: IncreaseCreditTypeEnum, item: IncreaseCreditListType) => {
      if (type === IncreaseCreditTypeEnum.AUTH_LIST) {
        goAuthentication(item);
      } else {
        goApply(item);
      }
    };

    /** 查看更多 */
    const onViewMoreClick = () => {
      ubtSetupPageButton('finance_qualityHomePage_increaseCredit_more');
      jumpToNewVersion(NewVersionEnum.INCREASE_CREDIT_ZONE, false);
    };

    onMounted(() => {
      if (adjustAuthList?.length) {
        ubtSetupModuleExpose('finance_qualityHomePage_increaseCredit');
      }

      if (carLoanList?.length) {
        ubtSetupModuleExpose('finance_qualityHomePage_carLoan');
      }
    });

    return {
      increaseCreditList,
      currentSelectData,
      currentDataContract,
      authDialogVisible,

      onListButtonClick,
      onViewMoreClick,
    };
  },
});
